var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0000215" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _c("c-appr-btn", {
                            ref: "appr-btn",
                            attrs: {
                              name: "work-permit-appr-btn",
                              editable: _vm.editable,
                              approvalInfo: _vm.approvalInfo,
                            },
                            on: {
                              beforeApprAction: _vm.approvalPreWorkCheck,
                              callbackApprAction:
                                _vm.approvalPreWorkCheckCallback,
                              requestAfterAction: function ($event) {
                                return _vm.getDetail("save")
                              },
                            },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.editable && !_vm.disabled,
                                expression: "editable && !disabled",
                              },
                            ],
                            attrs: {
                              isSubmit: _vm.isSave,
                              url: _vm.saveUrl,
                              param: _vm.preWorkCheck,
                              mappingType: _vm.mappingType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.savePreWorkCheck,
                              btnCallback: _vm.savePreWorkCheckCallback,
                            },
                          }),
                          _c("c-btn", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.editable && !_vm.disabled && _vm.isOld,
                                expression: "editable && !disabled && isOld",
                              },
                            ],
                            attrs: { label: "LBLREMOVE", icon: "remove" },
                            on: { btnClicked: _vm.removePreWorkCheck },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                      [
                        _c("c-text", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "점검명",
                            name: "checkName",
                          },
                          model: {
                            value: _vm.preWorkCheck.checkName,
                            callback: function ($$v) {
                              _vm.$set(_vm.preWorkCheck, "checkName", $$v)
                            },
                            expression: "preWorkCheck.checkName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
                      [
                        _c("c-multi-select", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            comboItems: _vm.checkClassItems,
                            itemText: "checkClassName",
                            itemValue: "sopPreWorkCheckClassId",
                            label: "점검구분대상",
                            name: "targets",
                          },
                          on: { datachange: _vm.changeTarget },
                          model: {
                            value: _vm.targets,
                            callback: function ($$v) {
                              _vm.targets = $$v
                            },
                            expression: "targets",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4 col-md-2 col-lg-2" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            data: _vm.preWorkCheck,
                            plantCd: _vm.preWorkCheck.plantCd,
                            deptValue: "deptCd",
                            type: "dept_user",
                            label: "관리감독자",
                            name: "managerId",
                          },
                          model: {
                            value: _vm.preWorkCheck.managerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.preWorkCheck, "managerId", $$v)
                            },
                            expression: "preWorkCheck.managerId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-8 col-md-4 col-lg-4" },
                      [
                        _c("c-multi-field", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            data: _vm.preWorkCheck,
                            isArray: false,
                            deptValue: "deptCd",
                            type: "dept_user",
                            label: "근로자",
                            name: "workerIds",
                          },
                          model: {
                            value: _vm.preWorkCheck.workerIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.preWorkCheck, "workerIds", $$v)
                            },
                            expression: "preWorkCheck.workerIds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4 col-md-2 col-lg-2" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            range: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "점검기간",
                            name: "checkPeriod",
                          },
                          model: {
                            value: _vm.preWorkCheck.checkPeriod,
                            callback: function ($$v) {
                              _vm.$set(_vm.preWorkCheck, "checkPeriod", $$v)
                            },
                            expression: "preWorkCheck.checkPeriod",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4 col-md-2 col-lg-2" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "LBL0000200",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.preWorkCheck.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.preWorkCheck, "plantCd", $$v)
                            },
                            expression: "preWorkCheck.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-tab", {
        staticClass: "q-mt-sm",
        attrs: {
          type: "tabcard",
          align: "left",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.componentKey,
                  ref: "swp-tab",
                  tag: "component",
                  attrs: {
                    popupParam: _vm.popupParam,
                    target: tab.target,
                    isOld: _vm.isOld,
                    disabled: _vm.disabled,
                    height: _vm.tabHeight,
                  },
                  on: {
                    "update:popupParam": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:popup-param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:target": function ($event) {
                      return _vm.$set(tab, "target", $event)
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }